export const WALLET_NAME = 'walletName';
export const CARDANO_WALLET_NAME = 'cardanoWalletName';
export const CARDANO_WALLET_EXTENSION_ERROR = 'WALLET_EXTENSION_NOT_FOUND';
export const USER_TOKEN = 'userToken';
